import {
    CLEAR_GENERATED_OFFRE_EMPLOI,
    FETCH_OFFRE_EMPLOI_BY_DEMANDE_FAIL,
    FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST,
    FETCH_OFFRE_EMPLOI_BY_DEMANDE_SUCCESS,
    GENERATE_OFFRE_EMPLOI_FAIL,
    GENERATE_OFFRE_EMPLOI_REQUEST,
    GENERATE_OFFRE_EMPLOI_SUCCESS,
    SAVE_OFFRE_EMPLOI_DRAFT_FAIL,
    SAVE_OFFRE_EMPLOI_DRAFT_REQUEST,
    SAVE_OFFRE_EMPLOI_DRAFT_SUCCESS,
} from "../actions/offresEmploiActions";

const initialState = {
    loading: false,
    saving: false,
    error: null,
    generatedOffer: null,
};

export default function offresEmploiReducer(state = initialState, action) {
    switch (action.type) {
        case GENERATE_OFFRE_EMPLOI_REQUEST:
        case FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case SAVE_OFFRE_EMPLOI_DRAFT_REQUEST:
            return {
                ...state,
                saving: true,
                error: null,
            };

        case GENERATE_OFFRE_EMPLOI_SUCCESS:
        case FETCH_OFFRE_EMPLOI_BY_DEMANDE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                generatedOffer: action.payload,
            };

        case SAVE_OFFRE_EMPLOI_DRAFT_SUCCESS:
            return {
                ...state,
                saving: false,
                error: null,
                generatedOffer: action.payload,
            };

        case GENERATE_OFFRE_EMPLOI_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case FETCH_OFFRE_EMPLOI_BY_DEMANDE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                generatedOffer: null,
            };

        case SAVE_OFFRE_EMPLOI_DRAFT_FAIL:
            return {
                ...state,
                saving: false,
                error: action.payload,
            };

        case CLEAR_GENERATED_OFFRE_EMPLOI:
            return initialState;

        default:
            return state;
    }
}
